import type { ApiErrorBody } from "../shared/types";

export class ApiError extends Error {
  constructor(public readonly status: number, public readonly code: string, message: string) {
    super(message);
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (typeof init.body === "string" && !headers.has("content-type")) headers.set("content-type", "application/json");
  const response = await fetch(path, { ...init, headers, credentials: "same-origin" });
  if (response.status === 401) window.dispatchEvent(new Event("vps360:unauthorised"));
  if (!response.ok) {
    const payload = await response.json().catch(() => ({ error: "The request could not be completed." })) as ApiErrorBody;
    throw new ApiError(response.status, payload.code || "request_failed", payload.error);
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}

export function jsonBody(value: unknown): RequestInit {
  return { body: JSON.stringify(value) };
}
